"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonCta = require("@mmc/common-cta");
var _articleListing = _interopRequireDefault(require("../styles/article-listing.css"));
var _articleListing2 = _interopRequireDefault(require("./article-listing.props/article-listing.defaultProps"));
var MoreButton = function MoreButton(_ref) {
  var text = _ref.text,
    theme = _ref.theme,
    changeLimitAmount = _ref.changeLimitAmount;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-md-10'] + " " + theme['col-md-offset-1'] + " " + _articleListing["default"].buttonWrapper + " " + theme.buttonsAndNav
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    data: {
      label: text,
      priority: 'lowIcon',
      icon: 'ChevronDown'
    },
    theme: theme,
    classes: ["" + _articleListing["default"].moreButton],
    clickEvent: changeLimitAmount
  }));
};
MoreButton.displayName = 'MoreButton';
MoreButton.defaultProps = {
  text: _articleListing2["default"],
  changeLimitAmount: function changeLimitAmount() {},
  theme: {}
};
var _default = MoreButton;
exports["default"] = _default;